import React from "react";
import { Flex, Box, Text, Container } from "@chakra-ui/react";
import { navigate } from "gatsby";
import { useLocation } from "@reach/router";
import { useSegment, GlobalSettingsSegment } from "../SegmentContext";

export const SegmentToggle: React.FC = () => {
  const { activeSegment, segments, hidePrefixes } = useSegment();
  const { pathname } = useLocation();

  // Check visibility rules
  const shouldHide = hidePrefixes.some(p => p.path && pathname.startsWith(p.path));

  if (shouldHide || segments.length === 0) return null;

  const handleToggle = (segmentId: string, urlPrefix: string) => {
    if (segmentId === activeSegment) return;

    // Ensure the prefix is safely formatted (always starts with /)
    let target = urlPrefix || "/";
    if (!target.startsWith("/")) target = `/${target}`;
    
    // We use a hard reload here instead of Gatsby's `navigate()` to safely tear down and boot up 
    // the heavy global CMP scripts (Didomi vs ConsentManager) which mutate the global window object.
    window.location.assign(target);
  };

  return (
    <Box w="full" bg="white">
      <Container
        size="block"
        display="flex"
        marginTop="space-16"
        paddingY="space-0"
        paddingX={{ base: "space-16", navbar: "space-58", "2xl": 0 }}
        justifyContent={{ base: "center", navbar: "flex-start" }}
      >
        <Flex
          bg="accounting-green-800"
          p="4px"
          borderRadius="full"
          alignItems="center"
          position="relative"
          w={{ base: "full", sm: "max-content" }}
        >
          {segments.map((seg: GlobalSettingsSegment) => {
            const isActive = activeSegment === seg.segment_id;
            return (
              <Box
                key={seg.segment_id}
                as="button"
                onClick={() => handleToggle(seg.segment_id, seg.url_prefix)}
                px={{ base: 2, sm: 4 }}
                py={1.5}
                borderRadius="full"
                bg={isActive ? "white" : "transparent"}
                color={isActive ? "accounting-green-800" : "white"}
                fontWeight="medium"
                transition="all 0.2s"
                zIndex={1}
                flex={{ base: 1, sm: "initial" }}
                textAlign="center"
              >
                <Text fontSize="13px" whiteSpace="nowrap">{seg.segment_label}</Text>
              </Box>
            );
          })}
        </Flex>
      </Container>
    </Box>
  );
};
